import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LoadData from './LoadData';
import './fonts/Mona-Sans.woff2';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<LoadData />);
